<div class="layout-footer">
    <div class="footer-start">
    </div>
    <div class="footer-end">
        <span>© DOT</span>
    </div>
</div>
